import { ReservacionModel } from "./ReservacionModel";
import { UsuarioModel } from "./UsuarioModel";

export class ParticipanteModel{
    public id?: number;
    public participante?: UsuarioModel;
    public reservacion?: ReservacionModel 

    constructor(participante?: any){
        participante = participante || {
            id: null,
            participante: {},
            reservacion: {}
        }

        this.id = participante.id;
        this.participante = participante.participante;
        this.reservacion = participante.reservacion;
    }
}